import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HttpService} from "../../services/http/http.service";
import {TipoStatoPropostaEnum, TipoStatoPropostaLabel} from "@enums";

const REALLOCATION_EXCEPTION_MESSAGE = 'Non è possibile decretare un profilo con un nome  già presente in un altra area. Contattare l\'assistenza';
const DIFFERENT_CODES_EXCEPTION_MESSAGE = 'Non è possibile inserire 2 profili con lo stesso nome con codici diversi.contattare l\'assistenza';

@Component({
  selector: 'app-replace-and-archive-profile-dialog',
  templateUrl: './replace-and-archive-profile-dialog.component.html',
  styleUrls: ['./replace-and-archive-profile-dialog.component.scss']
})
export class ReplaceAndArchiveProfileDialog implements OnInit {

  checkOverrideProposta: boolean = false;
  duplicatedProposal: any = {};
  newProfile: any;
  oldProfileCode: any;
  oldStatoProposta: {id: number, description: string, ordinamento?: number};
  constructor(
    public dialogRef: MatDialogRef<ReplaceAndArchiveProfileDialog>,
    private readonly snackBar: MatSnackBar,
    private readonly api: HttpService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  get existingProfileCode(){
    return this.duplicatedProposal?.profilo?.codiceProfilo
  }

  get existingProfileName(){
    return this.duplicatedProposal?.profilo?.nomeProfilo
  }

  get codiceProfilo(){
    return this.data.toReallocate ? this.data.code : this.duplicatedProposal?.profilo?.codiceProfilo;
  }

  ngOnInit() {
    this.checkOverrideProposta = true;
    this.duplicatedProposal = this.data.duplicatedProposal;
    this.newProfile = this.data.newProfile;
    this.oldStatoProposta = this.newProfile.statoProposta;
    this.oldProfileCode = this.newProfile.codiceProfilo;
    this.newProfile.codiceProfilo = this.codiceProfilo;
  }

  replaceAndArchive() {
    const paylod = {... this.duplicatedProposal};
    paylod.profilo = this.newProfile;

    this.api.archiviaProfiloEProposta(paylod, this.data.idProposta)
      .subscribe({
        next: () => {
          this.newProfile.statoProposta = { id: TipoStatoPropostaEnum.DECRETATA, descrizione: TipoStatoPropostaLabel[TipoStatoPropostaEnum.DECRETATA]};
          this.handleDialogClose();
        }
      });
  }

  reject(){
    this.snackBar.open(this.data.toReallocate ? REALLOCATION_EXCEPTION_MESSAGE : DIFFERENT_CODES_EXCEPTION_MESSAGE, 'close', { panelClass: 'errorSnack' });
    this.data.confirm = false;
    this.newProfile.statoProposta = this.oldStatoProposta;
    this.newProfile.codiceProfilo = this.oldProfileCode;
    this.dialogRef.close(this.data);
  }


  onClose(): void {
    this.dialogRef.close();
  }

  handleDialogClose() {
    this.data.confirm = true;
    this.dialogRef.close(this.data);
  }
}
